
import { defineComponent, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import Questionnaire from "@/components/Questionnaire.vue";
import store from "@/stores";
import Footer from "@/components/Footer.vue";
import { toResourceUrl } from "@/lib/shared";
import { consts } from "@/services/Models";

export default defineComponent({
  name: "Top",
  components: {
    Questionnaire,
    Footer,
  },
  setup() {
    const router = useRouter();
    const auth = store.useAuthStore();
    // テンプレート選択画面へ
    const toTemplateList = () => {
      router.push({ name: routeNames.SelectTemplate });
    };
    const isShowModal = ref(false);
    // アンケートダイアログ
    const openQuestionnaire = () => {
      isShowModal.value = true;
    };
    // セリフ付きサンプル選択画面へ
    const toSampleDataList = () => {
      router.push({ name: routeNames.SelectSampleData });
    };

    const resource = store.useResource();
    // メンテナンス情報
    const messages = computed(() =>
      resource.data.manageContent.message.split("\n")
    );
    const isNotEmptyMessage = computed(
      () => !!resource.data.manageContent.message
    );
    const bgText = computed(() => toResourceUrl(consts.topBgText));

    return {
      toTemplateList,
      isShowModal,
      openQuestionnaire,
      toSampleDataList,
      messages,
      isNotEmptyMessage,
      bgText,
      ...auth,
    };
  },
});
